import { request } from '@/api';

export const getIndexArticlesAPI = async (payload) => {
  const res = await request({
    method: 'get',
    url: '/articles/view',
    params: payload,
  });
  return res.data;
};

export const getViewArticlesAPI = async (payload, otherArgs) => {
  const {
    type, pageIndex, category, limit,
  } = payload;

  const limitCount = limit || 8;

  const params = {
    type,
    page: pageIndex,
    limit: limitCount,
    category,
  };

  if (otherArgs?.noLimit) {
    delete params.limit;
  }

  const res = await request({
    method: 'get',
    url: '/articles',
    params,
  });
  return res.data;
};
